import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MessageCircle, X, MessageSquareText } from "lucide-react";
import { useLang } from "../i18n";

const PHONE = "+16892666616";
const WA = "16892666616";

export default function FloatingContact() {
  const { t } = useLang();
  const [open, setOpen] = useState(false);
  const msg = encodeURIComponent(t.floating.sms);

  return (
    <div className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-50 flex flex-col items-end gap-3" data-testid="floating-contact">
      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: 12, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 12, scale: 0.9 }}
            transition={{ duration: 0.25, ease: [0.16, 1, 0.3, 1] }}
            className="flex flex-col gap-2.5 items-end"
          >
            <a
              href={`sms:${PHONE}${navigatorSep()}body=${msg}`}
              className="inline-flex items-center gap-2.5 rounded-full bg-charcoal text-crema pl-5 pr-6 py-3.5 shadow-xl hover:bg-coral transition-colors duration-300"
              data-testid="floating-sms"
            >
              <MessageSquareText className="h-5 w-5" />
              <span className="text-sm font-semibold whitespace-nowrap">{t.floating.text}</span>
            </a>
            <a
              href={`https://wa.me/${WA}?text=${msg}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2.5 rounded-full bg-crema text-charcoal border border-charcoal/10 pl-5 pr-6 py-3.5 shadow-xl hover:border-teal transition-colors duration-300"
              data-testid="floating-whatsapp"
            >
              <MessageCircle className="h-5 w-5 text-teal" />
              <span className="text-sm font-semibold whitespace-nowrap">{t.floating.whatsapp}</span>
            </a>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="flex items-center gap-3">
        <AnimatePresence>
          {!open && (
            <motion.span
              initial={{ opacity: 0, x: 10 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: 10 }}
              className="hidden sm:block rounded-full bg-crema/90 backdrop-blur border border-charcoal/10 px-4 py-2 text-xs font-semibold text-charcoal shadow-md"
            >
              {t.floating.label}
            </motion.span>
          )}
        </AnimatePresence>
        <button
          onClick={() => setOpen((v) => !v)}
          aria-label={t.floating.label}
          className="grid place-items-center h-14 w-14 rounded-full bg-teal text-crema shadow-[0_12px_30px_-8px_rgba(15,110,86,0.7)] hover:brightness-110 transition-all duration-300 active:scale-95"
          data-testid="floating-toggle"
        >
          <AnimatePresence mode="wait" initial={false}>
            {open ? (
              <motion.span key="x" initial={{ rotate: -90, opacity: 0 }} animate={{ rotate: 0, opacity: 1 }} exit={{ rotate: 90, opacity: 0 }} transition={{ duration: 0.2 }}>
                <X className="h-6 w-6" />
              </motion.span>
            ) : (
              <motion.span key="chat" initial={{ rotate: 90, opacity: 0 }} animate={{ rotate: 0, opacity: 1 }} exit={{ rotate: -90, opacity: 0 }} transition={{ duration: 0.2 }}>
                <MessageCircle className="h-6 w-6" />
              </motion.span>
            )}
          </AnimatePresence>
        </button>
      </div>
    </div>
  );
}

// iOS uses `&body=` after existing params but sms: has no query; use `?` then body.
function navigatorSep() {
  return "?";
}
